// English translations (default)
export const translations = {
  en: {
    // App header
    appName: 'Ups & Downs',
    dashboard: 'Dashboard',
    friendships: 'Friendships',
    journeys: 'Journeys',
    friendshipGoals: 'Friendship Goals',
    signIn: 'Sign In',
    getStarted: 'Get Started',
    
    // Auth
    welcomeBack: 'Welcome Back',
    joinNow: 'Join Now',
    signInDescription: 'Sign in to continue building strong friendships',
    signUpDescription: 'Start building closer friendships today',
    yourName: 'Your Name',
    enterYourName: 'Enter your name',
    email: 'Email',
    enterYourEmail: 'Enter your email',
    password: 'Password',
    enterYourPassword: 'Enter your password',
    pleaseWait: 'Please wait...',
    signInButton: 'Sign In',
    createAccount: 'Create Account',
    forgotPassword: 'Forgot your password?',
    enterEmailForReset: 'Enter your email above, then click "Forgot your password?"',
    passwordResetEmailSent: 'Password reset email sent. Check your inbox.',
    dontHaveAccount: "Don't have an account? ",
    alreadyHaveAccount: 'Already have an account? ',
    signUp: 'Sign up',
    signInLink: 'Sign in',
    agreeToTerms: 'By signing up, you agree to our',
    termsAndConditions: 'Terms and Conditions',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    
    // Auth errors
    fillAllFields: 'Please fill in all fields',
    enterName: 'Please enter your name',
    acceptTermsRequired: 'Please accept the Terms and Conditions and Privacy Policy to continue',
    emailAlreadyInUse: 'An account with this email already exists',
    invalidEmail: 'Invalid email address',
    weakPassword: 'Password should be at least 6 characters',
    userNotFound: 'No account found with this email',
    wrongPassword: 'Incorrect password',
    tooManyRequests: 'Too many failed attempts. Please try again later',
    networkError: 'Network error. Please check your connection and try again',
    authNotEnabled: 'Email/password authentication is not enabled. Please contact support',
    userDisabled: 'This account has been disabled. Please contact support',
    signInFailed: 'Failed to sign in. Please try again',
    
    // User profile
    user: 'User',
    subscription: 'Subscription',
    signOut: 'Sign Out',
    
    // Dashboard
    welcomeBackDashboard: 'Welcome back! 👋',
    dashboardSubtitle: "Here's what's happening with your friendships",
    totalFriends: 'Total Friends',
    needAttention: 'Need Attention',
    allGood: 'All Good',
    daysSinceLastInteraction: 'Days Since Last Interaction',
    yourFriendshipGoals: 'Your Friendship Goals',
    manageGoals: 'Manage Goals',
    goalsCompleted: 'goals completed',
    of: 'of',
    moreGoals: 'more goal',
    moreGoalsPlural: 'more goals',
    discoverFriendshipNeeds: 'Discover Your Friendship Needs',
    takeAssessmentDescription: 'Take our quick assessment to understand what you need from friendships and set goals to track your progress toward friendship success.',
    takeAssessment: 'Take Assessment',
    quickActions: 'Quick Actions',
    manageFriendships: 'Manage Friendships',
    startJourney: 'Start Journey',
    myFriendshipNeeds: 'My Friendship Needs',
    friendshipHealth: 'Friendship Health',
    viewAll: 'View All',
    noFriendsYet: 'No friends yet',
    noFriendsDescription: 'Start building your friendship network by adding your first friend!',
    addFirstFriend: 'Add Your First Friend',
    recentInteractions: 'Recent Interactions',
    loadingDashboard: 'Loading your dashboard...',
    never: 'Never',
    today: 'Today',
    dayAgo: 'day ago',
    daysAgo: 'days ago',
    monthAgo: 'month ago',
    monthsAgo: 'months ago',
    moreThanMonthAgo: 'more than 1 month ago',
    moreThanMonthsAgo: 'more than {count} months ago',
    lastContact: 'Last contact:',
    timeToTakeAction: 'Time to Take Action',
    allCaughtUp: 'All caught up! No friends need attention right now.',
    allGoodCategory: 'All Good',
    noFriendsInCategory: 'No friends in this category yet.',
    
    // Friendship Tracker
    friendshipTracker: 'Friendship Tracker',
    trackerSubtitle: 'Keep your relationships strong by staying connected',
    friends: 'Friends',
    healthyRelationships: 'Healthy Relationships',
    timeToTakeActionTracker: 'Time To Take Action',
    needAttentionTracker: 'Need Attention',
    addFriend: 'Add Friend',
    back: 'Back',
    addNewFriend: 'Add New Friend',
    name: 'Name',
    nameRequired: 'Name *',
    friendsName: "Friend's name",
    relationship: 'Relationship',
    contactFrequency: 'Contact Frequency',
    phone: 'Phone',
    phoneNumber: 'Phone number',
    emailAddress: 'Email address',
    lastContactDate: 'Last Contact Date',
    notes: 'Notes',
    notesPlaceholder: 'Any notes about this friendship...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    countsAsCloseFriend: 'Counts as Close Friend',
    countsAsCloseFriendHint: 'Mark this friend as counting toward your close friends goal, regardless of relationship type',
    
    // Contact types
    call: 'Call',
    email: 'Email',
    text: 'Text',
    meeting: 'Meeting',
    video: 'Video',
    lunch: 'Lunch',
    dinner: 'Dinner',
    coffee: 'Coffee',
    activity: 'Activity',
    
    // Contact frequency
    daily: 'Daily',
    weekly: 'Weekly',
    biweekly: 'Bi-weekly',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    
    // Relationship types
    friend: 'Friend',
    bestFriend: 'Best Friend',
    colleague: 'Colleague',
    family: 'Family',
    acquaintance: 'Acquaintance',
    mentor: 'Mentor',
    neighbor: 'Neighbor',
    
    // Status messages
    allGoodStatus: 'All good!',
    timeToReachOut: 'Time to reach out',
    needsAttentionStatus: 'Needs attention',
    
    // Premium
    upgradeToPremium: '🚀 Upgrade to Premium',
    friendLimitReached: "You've reached the free limit of 1 friend. Upgrade to Premium to add unlimited friends!",
    journeyAccess: 'Journeys are a Premium feature. Upgrade to unlock guided friendship journeys!',
    upgradeGeneral: 'Upgrade to Premium to unlock all features and unlimited friends!',
    premiumFeatures: 'Premium Features:',
    unlimitedFriends: 'Unlimited friends',
    guidedJourneys: 'Guided friendship journeys',
    advancedTracking: 'Advanced tracking & analytics',
    cancelAnytime: 'Cancel anytime',
    upgradeNow: 'Upgrade Now',
    maybeLater: 'Maybe Later',
    processing: 'Processing...',
    paymentSystemNotAvailable: 'Payment system not available. Please try again later.',
    paymentFailed: 'Payment failed: {message}',
    failedToStartPayment: 'Failed to start payment: {message}',
    
    // Payment messages
    paymentSuccessful: '🎉 Payment successful! You now have premium access.',
    paymentCancelled: 'Payment cancelled. You can try again anytime.',
    
    // Simple Friends List
    friendshipOverview: 'Friendship overview',
    quickGlance: 'Quick glance of the health of your friendships',
    signInToSeeFriends: 'Sign in to see your friends and last connections.',
    loading: 'Loading…',
    noFriendsYetTracker: 'No friends yet. Add a few in the tracker.',
    
    // Feature Cards
    readyToTransform: 'Ready to Transform Your Friendships?',
    joinToday: "Join today if you're ready to improve your social connections",
    
    // Common
    lastConnected: 'Last connected ·',
    
    // Language switcher
    language: 'Language',
    english: 'English',
    danish: 'Danish',
    
    // Friendship Tracker - Additional
    appointments: 'Appointments',
    contactHistory: 'Contact History',
    scheduleAppointment: 'Schedule Appointment',
    noFriendsTrackedYet: 'No friends tracked yet',
    addFirstFriendToStart: 'Add your first friend to start tracking your relationships!',
    addFriendWithLimit: 'Add Friend ({count}/1)',
    initialGoalsOptional: 'Initial Goals (Optional)',
    goalTitlePlaceholder: 'Goal title (e.g., Meet more often)',
    addAnotherGoal: 'Add Another Goal',
    removeLastGoal: 'Remove Last Goal',
    currentGoals: 'Current goals:',
    canAddMultipleGoals: 'You can add multiple goals and edit them later in the friendship tracker.',
    manageGoals: 'Manage Goals',
    setGoals: 'Set Goals',
    editNotes: 'Edit Notes',
    removeFriend: 'Remove Friend',
    recordContact: 'Record Contact',
    viewDetails: 'View Details',
    startJourney: 'Start Journey',
    selectFriendshipType: 'Select Friendship Type',
    daysSince: 'days since',
    lastContacted: 'last contacted',
    contactFrequencyLabel: 'Contact Frequency:',
    noNotesYet: 'No notes yet',
    noGoalsYet: 'No goals set yet',
    addGoal: 'Add Goal',
    goalTitle: 'Goal Title',
    goalDescription: 'Description',
    goalCategory: 'Category',
    targetDate: 'Target Date',
    connection: 'Connection',
    communication: 'Communication',
    funActivities: 'Fun & Activities',
    support: 'Support',
    personalGrowth: 'Personal Growth',
    other: 'Other',
    
    // Friend Profile
    friendProfile: 'Friend Profile',
    backToHome: 'Back to Home',
    birthday: 'Birthday',
    editBirthday: 'Edit Birthday',
    saveBirthday: 'Save Birthday',
    upcomingAppointments: 'Upcoming Appointments',
    noUpcomingAppointments: 'No upcoming appointments',
    pastInteractions: 'Past Interactions',
    noPastInteractions: 'No past interactions yet',
    goals: 'Goals',
    friendshipType: 'Friendship Type',
    editProfile: 'Edit Profile',
    showInteractionHistory: 'Show Interaction History',
    interactionHistory: 'Interaction History',
    interaction: 'interaction',
    interactions: 'interactions',
    reflectionEvaluation: 'Reflection Evaluation',
    logInteraction: 'Log Interaction',
    setGoalsForFriend: 'Set Goals for Friend',
    notesOnFriend: 'Notes on Friend',
    selectFriendshipTypeModal: 'Select Friendship Type',
    friendshipNeedsAssessment: 'Friendship Needs Assessment',
    friendshipNeedsAssessmentQuestionnaire: 'Friendship Needs Assessment Questionnaire',
    startNewJourneyModal: 'Start New Journey',
    noContactHistoryYet: 'No contact history yet',
    startReachingOut: 'Start reaching out to friends to build your contact history!',
    goalsFor: 'Goals for',
    lastInteraction: 'Last interaction',
    typeOfFriendship: 'Type of friendship',
    nextAppointment: 'Next appointment',
    friendshipOverviewTitle: 'Friendship overview',
    with: 'with',
    for: 'for',
    to: 'to',
    howWasConversation: 'How was the conversation?',
    topicsDiscussed: 'Topics discussed',
    highlights: 'Highlights',
    nextSteps: 'Next steps',
    currentGoals: 'Current Goals',
    selectCategory: 'Select a category',
    targetDateOptional: 'Target Date (Optional)',
    loadingFriendProfile: 'Loading friend profile...',
    friendNotFound: 'Friend not found',
    overallReflection: 'Overall reflection',
    notProvided: 'Not provided',
    
    // Friend Profile - Overview Cards
    notSetYet: 'No goals set yet',
    nothingPlannedYet: 'Nothing scheduled yet',
    data: 'Data',
    comingSoon: 'Coming soon',
    tapToEdit: 'Tap to edit',
    
    // Friendship Types (for modal)
    friendshipTypeAcquaintance: 'Acquaintance or Casual',
    friendshipTypeAcquaintanceDesc: 'People you know by name and interact with occasionally (coworkers, neighbors, classmates).',
    friendshipTypeActivityBased: 'Activity-Based',
    friendshipTypeActivityBasedDesc: 'Centered on a shared hobby or context, like a gym buddy or gaming partner.',
    friendshipTypeSituational: 'Situational or Circumstantial',
    friendshipTypeSituationalDesc: 'Formed because you are in the same life stage or environment (college roommate, new-parent group).',
    friendshipTypeClose: 'Close or Best Friend',
    friendshipTypeCloseDesc: 'Deep mutual affection, trust, and consistent emotional support.',
    friendshipTypeLifelong: 'Lifelong or Kindred Spirit',
    friendshipTypeLifelongDesc: 'Relationships that persist across decades and life changes.',
    friendshipTypeMentorMentee: 'Mentor-Mentee',
    friendshipTypeMentorMenteeDesc: 'A friendship where one person is significantly more experienced or older.',
    friendshipTypeWorkplace: 'Workplace or Professional',
    friendshipTypeWorkplaceDesc: 'Colleagues with whom you share camaraderie beyond formal duties.',
    friendshipTypeChosenFamily: 'Chosen Family',
    friendshipTypeChosenFamilyDesc: 'Friends who fill roles similar to family, especially when biological family is absent or distant.',
    friendshipTypeDigitalFirst: 'Digital-First or Online',
    friendshipTypeDigitalFirstDesc: 'Bonds formed primarily through digital spaces (gaming communities, social media, forums).',
    
    // Reflection Prompt (Quick Reflection)
    quickReflection: 'Quick Reflection',
    howWasYourContact: 'How was your {contactType} with {name}?',
    // Step titles
    stepTitleHowWasConversation: 'How was your conversation?',
    stepTitleWhatDidYouTalkAbout: 'What did you talk about?',
    stepTitleWhatWereHighlights: 'What were the highlights?',
    stepTitleAnyNextSteps: 'Any next steps?',
    stepTitleOverallReflection: 'Overall reflection',
    // Step descriptions
    stepDescRateConversation: 'Rate how the conversation went overall',
    stepDescSelectTopics: 'Select the main topics you discussed',
    stepDescBestMoments: 'What were the best moments or most meaningful parts? (Optional)',
    stepDescPlansCommitments: 'Did you make any plans or commitments? (Optional)',
    stepDescFinalThoughts: 'Any final thoughts about this interaction? (Optional)',
    // Mood options
    moodExcellent: 'Excellent',
    moodGood: 'Good',
    moodOkay: 'Okay',
    moodDifficult: 'Difficult',
    // Topic options
    topicWorkCareer: 'Work & Career',
    topicFamilyRelationships: 'Family & Relationships',
    topicHealthWellness: 'Health & Wellness',
    topicHobbiesInterests: 'Hobbies & Interests',
    topicTravelAdventures: 'Travel & Adventures',
    topicGoalsDreams: 'Goals & Dreams',
    topicChallengesStruggles: 'Challenges & Struggles',
    topicCelebrationsAchievements: 'Celebrations & Achievements',
    topicCurrentEvents: 'Current Events',
    topicMemoriesNostalgia: 'Memories & Nostalgia',
    topicFuturePlans: 'Future Plans',
    topicOther: 'Other',
    // Placeholders
    pleaseSpecify: 'Please specify...',
    placeholderHighlights: 'What were the best moments? What made you smile or feel connected?',
    placeholderNextSteps: 'Did you make any plans? Set any goals? Promise to do something together?',
    placeholderOverall: 'Any final thoughts? How do you feel about your friendship right now?',
    // Buttons
    back: 'Back',
    next: 'Next',
    saveReflection: 'Save Reflection',
    
    // Schedule Appointment Modal
    scheduleAppointmentTitle: 'Schedule Appointment',
    upcomingAppointments: 'Upcoming Appointments',
    friendLabel: 'Friend',
    titleLabel: 'Title *',
    titlePlaceholder: 'e.g., Coffee catch-up, Dinner, Phone call',
    dateLabel: 'Date *',
    timeLabel: 'Time *',
    typeLabel: 'Type',
    appointmentTypeMeeting: 'In-person Meeting',
    appointmentTypeCall: 'Phone Call',
    appointmentTypeVideo: 'Video Call',
    appointmentTypeLunch: 'Lunch',
    appointmentTypeDinner: 'Dinner',
    appointmentTypeCoffee: 'Coffee',
    appointmentTypeActivity: 'Activity',
    appointmentTypeOther: 'Other',
    locationLabel: 'Location',
    locationPlaceholder: 'Where are you meeting?',
    notesLabel: 'Notes',
    notesPlaceholderAppointment: 'Any additional notes about this appointment...',
    confirmDeleteAppointment: 'Are you sure you want to delete this appointment?',
    
    // Set Goals Modal
    goalTitleLabel: 'Goal Title *',
    goalTitlePlaceholder: 'e.g., Meet more often, Have deeper conversations',
    goalDescriptionLabel: 'Description',
    goalDescriptionPlaceholder: 'Describe what you want to achieve...',
    goalCategoryLabel: 'Category *',
    goalCategoryConnection: 'Connection',
    goalCategoryCommunication: 'Communication',
    goalCategoryFun: 'Fun & Activities',
    goalCategorySupport: 'Support',
    goalCategoryGrowth: 'Personal Growth',
    goalCategoryOther: 'Other',
    targetLabel: 'Target:',
    addGoal: 'Add Goal',
    confirmDeleteGoal: 'Are you sure you want to delete this goal?',
    
    // Edit Notes
    notesPlaceholderFriend: 'Jot a few personal notes (interests, context, etc.)',
    
    // Journeys
    reconnectAndDeepen: 'Reconnect and deepen your friendship',
    journeyDescription: 'A 4-week online self-paced, science-backed journey to rebuild closeness through small, meaningful moments — without awkwardness or over-investing.',
    weeks: 'weeks',
    days: 'days',
    activities: 'activities',
    all: 'All',
    active: 'Active',
    completed: 'Completed',
    startJourneyWith: 'Start Journey with',
    selectFriend: 'Select Friend',
    noFriendsForJourney: 'No friends available. Add a friend first!',
    journeyProgress: 'Journey Progress',
    week: 'Week',
    completedActivities: 'completed',
    ofActivities: 'of',
    backToJourneys: 'Back to Journeys',
    overview: 'Overview',
    // Journey Objectives
    objectiveReachOut: 'Reach out with confidence and self-respect',
    objectiveBuildRhythms: 'Build sustainable friendship rhythms that fit adult life',
    objectiveDeepenConnection: 'Deepen emotional connection safely and mutually',
    // Journey Overview
    loadingPersonalizedJourney: 'Loading your personalized journey...',
    personalizationForYou: 'Personalized for you',
    personalizationRefresh: 'Update from my reflections',
    personalizationUpdating: 'Updating…',
    personalizationNeedReflections: 'Write a reflection in any week, then tap update to tailor this overview to what you shared.',
    personalizationThemesHeading: 'Themes we noticed',
    personalizationEmptyError: 'No personalization was returned. Please try again.',
    personalizationGenericError: 'Something went wrong. Please try again in a moment.',
    overallProgress: 'Overall Progress',
    activitiesCompleted: 'activities completed',
    journeyObjectives: 'Journey Objectives',
    your4WeekJourney: 'Your 4-Week Journey',
    startWeek: 'Start Week',
    completeWeekFirst: 'Complete Week {week} first',
    journeyComplete: '🎉 Journey Complete!',
    journeyCompleteMessage: 'Congratulations! You\'ve completed all {total} activities across all 4 weeks. Keep nurturing your friendship and continue building on the connections you\'ve made.',
    reviewJourney: 'Review Journey',
    continueYourJourney: 'Continue Your Journey',
    continueWeek: 'Continue {weekTitle}',
    completeWeekFirstMessage: 'Finish all activities in {week} to unlock {nextWeek}.',
    goToWeek: 'Go to {week}',
    readyToBegin: 'Ready to Begin?',
    readyToBeginMessage: 'Start with Week 1 to begin your journey toward deeper, more meaningful friendships.',
    beginWeek1: 'Begin Week 1: Prepare & Reach Out',
    // Week Titles
    week1Title: 'Week 1: Prepare & Reach Out',
    week2Title: 'Week 2: Rebuild Rhythm',
    week3Title: 'Week 3: Deepen with Consent',
    week4Title: 'Week 4: Lock It In',
    // Week Focuses
    week1Focus: 'Choose the right friendship, set healthy expectations, and send one grounded reconnection message',
    week1FocusWithFriend: 'Choose the right friendship, set healthy expectations, and send one grounded reconnection message to {name}',
    week2Focus: 'Create a light, sustainable rhythm - without chasing or over-investing',
    week2FocusWithFriend: 'Create a light, sustainable rhythm with {name} - without chasing or over-investing',
    week3Focus: 'Increase emotional depth only where safety and reciprocity exist',
    week3FocusWithFriend: 'Increase emotional depth with {name} only where safety and reciprocity exist',
    week4Focus: 'Create structures that survive real life',
    week4FocusWithFriend: 'Create structures with {name} that survive real life',
    // Week Activities
    activityFriendshipFit: 'Friendship Fit & Safety Check',
    activityFriendshipFitWithFriend: 'Friendship Fit & Safety Check with {name}',
    activityClarifyIntention: 'Clarify Your Intention',
    activityCraftMessage: 'Craft and Send the Message',
    activityReadResponse: 'Read the Response Clearly',
    activityReadResponseWithFriend: 'Read the Response Clearly from {name}',
    activityMicroConnection: 'Create One Micro-Connection',
    activityBalanceCheck: 'Connection Balance Check',
    activityGoDeeper: 'Go One Level Deeper',
    activityGoDeeperWithFriend: 'Go One Level Deeper with {name}',
    activityShareTruth: 'Share a Small, Real Truth',
    activityDeepListening: 'Practice Deep Listening',
    activityDesignRitual: 'Design a Friendship Ritual',
    activityDesignRitualWithFriend: 'Design a Friendship Ritual with {name}',
    activityRestartRule: 'Create a Restart Rule',
    activityFinalIntegration: 'Final Integration & Celebration',
    // Week Completion Messages
    completeWeek1Start2: 'Complete Week 1 → Start Week 2',
    completeWeek2Start3: 'Complete Week 2 → Start Week 3',
    completeWeek3Start4: 'Complete Week 3 → Start Week 4',
    congratulationsJourneyComplete: '🎉 Congratulations! You\'ve completed the 4-Week Journey!',
    // Start Journey Modal
    step1ChooseJourneyType: 'Step 1: Choose Journey Type',
    step2ChooseFriend: 'Step 2: Choose Friend',
    noFriendsForJourneyMessage: 'You don\'t have any friends yet. Please add friends in the Friendship Tracker first.',
    goToFriendshipTrackerButton: 'Go to Friendship Tracker',
    existingJourney: 'existing journey',
    existingJourneys: 'existing journeys',
    startJourney: 'Start Journey',
    quickActions: 'Quick Actions',
    // Assessment Questions - Categories
    categoryConnectionDepth: 'Connection Depth',
    categorySocialEnergy: 'Social Energy',
    categorySupportNeeds: 'Support Needs',
    categoryCommunication: 'Communication',
    categoryGoals: 'Goals',
    categorySocialCircle: 'Social Circle',
    categoryTimeInvestment: 'Time Investment',
    categoryConflictBoundaries: 'Rupture Response',
    categoryRepairStyle: 'Repair Style',
    categoryInitiationBalance: 'Initiation Balance',
    // Assessment Questions
    questionConnectionDepth: 'What level of emotional depth do you want most of your close friendships to have?',
    questionSocialEnergy: 'How much social interaction energizes you? There\'s no right answer — this is about how you recharge best.',
    questionSupportType: 'When life is challenging, what do you most want from close friends?',
    questionCommunicationStyle: 'What level of contact helps you feel connected without feeling overwhelmed?',
    questionFriendshipGoals: 'What role do you most want friendships to play in your life right now?',
    questionFriendshipQuantity: 'How many close friendships do you want to maintain? Quality and quantity both matter — this helps us understand your preference.',
    questionTimeInvestment: 'How much time and energy can you realistically invest in friendships most weeks?',
    questionConflictHandling: 'When something feels off in a friendship, what do you usually do first?',
    questionRepairStyle: 'After a misunderstanding, what helps you feel close again?',
    questionInitiationBalance: 'In most friendships, who usually initiates contact?',
    // Assessment Options - Connection Depth
    optionDeep: 'Deep, emotionally open connections where we share real struggles',
    optionBalanced: 'A mix of deep conversations and lighter, fun connection',
    optionCasual: 'Mostly light, positive friendships with occasional depth',
    // Assessment Options - Social Energy
    optionHigh: 'I thrive on frequent social interaction',
    optionModerate: 'I enjoy regular social time but need balance',
    optionLow: 'I prefer less frequent but quality interactions',
    // Assessment Options - Support Type
    optionEmotional: 'Emotional understanding and being heard',
    optionPractical: 'Practical help and doing things together',
    optionBoth: 'A balance of emotional and practical support',
    // Assessment Options - Communication Style
    optionFrequent: 'Frequent check-ins (daily or several times a week)',
    optionRegular: 'Regular contact (weekly or bi-weekly)',
    optionOccasional: 'Occasional but meaningful contact (monthly or as needed)',
    // Assessment Options - Friendship Goals
    optionGrowth: 'Personal growth and learning together',
    optionFun: 'Having fun and sharing experiences',
    optionSupport: 'Mutual support through life challenges',
    optionAll: 'A balanced mix that adapts to different life phases',
    // Assessment Options - Friendship Quantity
    optionFew: 'A few very close friends (2-4)',
    optionModerateCircle: 'A moderate circle (5-8 close friends)',
    optionMany: 'A larger social circle (9+ friends)',
    // Assessment Options - Time Investment
    optionHighTime: 'I can invest significant time regularly',
    optionModerateTime: 'I can invest moderate time with some planning',
    optionLimited: 'I have limited time, so quality over quantity',
    // Assessment Options - Conflict Handling
    optionDirect: 'Bring it up directly and talk it through',
    optionGentle: 'Sit with it and address it gently later',
    optionAvoid: 'Pull back and see if it resolves on its own',
    // Assessment Options - Repair Style
    optionTalkThrough: 'Talking it through openly',
    optionApologyBehavior: 'A sincere apology and changed behavior',
    optionTimeNormal: 'Time passing and returning to normal',
    optionSharedExperiences: 'Shared positive experiences',
    // Assessment Options - Initiation Balance
    optionMostlyMe: 'Mostly me',
    optionAboutEqual: 'About equal',
    optionMostlyThem: 'Mostly them',
    optionVaries: 'It varies a lot',
    
    // Subscription Management
    subscriptionManagement: 'Subscription Management',
    backToHome: 'Back to Home',
    currentStatus: 'Current Status',
    premium: 'Premium',
    free: 'Free',
    loadingSubscriptionInfo: 'Loading subscription information...',
    manageSubscription: 'Manage Subscription',
    upgradeToPremium: 'Upgrade to Premium',
    unableToOpenPortal: 'Unable to open subscription management. ',
    portalNotConfigured: 'The customer portal is not configured yet. Please contact support.',
    noSubscriptionFound: 'No subscription found. Please upgrade to premium first.',
    premiumFeatures: 'Premium Features',
    deepeningRelationshipsJourney: 'Deepening Relationships Journey',
    journeyDescriptionShort: '4-week guided journey to strengthen your friendships',
    friendshipTrackerFeature: 'Friendship Tracker',
    friendshipTrackerDescription: 'Track and manage your friendships with detailed insights',
    syncSubscriptionStatus: 'Sync your subscription status from Stripe',
    syncing: 'Syncing...',
    syncStatus: '🔄 Sync Status',
    unlockPremiumFeatures: 'Unlock all premium features to get the most out of Ups & Downs:',
    yourCurrentAccess: 'Your Current Access:',
    accessTo1Friend: '✅ Access to 1 friend (all your friend data is preserved)',
    journeysPaused: '❌ Journeys are paused',
    cannotAddMoreFriends: '❌ Cannot add more friends',
    upgradeToRestoreAccess: 'Upgrade to restore full access to all friends and journeys!',
    joinOnlineJourneys: 'Join online journeys to strengthen your friendships',
    accountInformation: 'Account Information',
    emailLabel: 'Email:',
    userIdLabel: 'User ID:',
    memberSince: 'Member since:',
    needHelp: 'Need Help?',
    supportMessage: 'If you have any questions about your subscription or need assistance, please contact our support team.',
    checkSubscriptionStatus: 'Check if you have an active subscription',
    checkSubscriptionStatusButton: '🔄 Check Subscription Status',
    subscriptionStatusUpdated: 'Subscription status updated! You now have premium access.',
    noActiveSubscription: 'No active subscription found. If you recently paid, please wait a moment and try again.',
    failedToSyncStatus: 'Failed to sync subscription status: {message}',
    // Contact History
    duration: 'Duration',
    durationLabel: 'Duration:',
    allInteractions: 'All Interactions',
    reload: '🔄 Reload',
    noInteractionsRecorded: 'No interactions recorded yet',
    at: 'at',
    scheduled: '📅 Scheduled',
    completed: '✅ Completed',
    cancelled: '❌ Cancelled',
    // Contact Form
    contactType: 'Contact Type',
    date: 'Date',
    time: 'Time',
    phoneCall: '📞 Phone Call',
    emailContact: '📧 Email',
    textMessage: '💬 Text Message',
    videoCall: '📹 Video Call',
    inPersonMeeting: '🤝 In-person Meeting',
    otherContact: '💭 Other',
    durationPlaceholder: 'e.g., 30 minutes, 1 hour, 2 hours',
    notesPlaceholderContact: 'What did you talk about? How did it go?',
    plannedAppointment: 'We planned a new appointment/meeting',
    appointmentDetails: 'Appointment Details',
    appointmentTitle: 'Appointment Title',
    appointmentDate: 'Appointment Date',
    appointmentTime: 'Appointment Time',
    appointmentTitlePlaceholder: 'e.g., Coffee catch-up, Dinner, Movie night',
    deleteContactRecord: 'Are you sure you want to delete this contact record?',
    viewReflection: 'View Reflection',
    // Interaction History Page
    activeJourneys: 'Active Journeys',
    started: 'Started:',
    activitiesCompletedCount: '{completed} of {total} activities completed ({percentage}%)',
    noAppointmentsScheduled: 'No appointments scheduled',
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgoCount: '{count} days ago',
    oneDayAgo: '1 day ago',
    oneWeekAgo: '1 week ago',
    profileDaysAgo: '{count} days ago',
    profileWeeksAgo: '{count} weeks ago',
    oneMonthAgo: '1 month ago',
    profileMonthsAgo: '{count} months ago',
    oneYearAgo: '1 year ago',
    profileYearsAgo: '{count} years ago',
    // Cadence Tracker (shown on interaction history page)
    interactionCadence: 'Interaction Cadence',
    excellentCadence: 'Excellent cadence!',
    goodConsistency: 'Good consistency',
    couldBeMoreConsistent: 'Could be more consistent',
    needsAttentionCadence: 'Needs attention',
    noDataYet: 'No data yet',
    currentStreak: 'Current Streak',
    bestStreak: 'Best Streak',
    avgGap: 'Avg. Gap',
    targetContact: 'Target: {frequency} contact',
    lastContact: 'Last Contact:',
    nextTarget: 'Next Target:',
    notSet: 'Not set',
    daysOverdue: '{count} days overdue',
    daysLeft: '{count} days left',
    tipsForBetterCadence: 'Tips for Better Cadence',
    doingAmazing: 'You\'re doing amazing! Keep up the great consistency with {name}.',
    greatJob: 'Great job! Try to maintain this rhythm with {name} to build an even stronger connection.',
    setReminder: 'Set a reminder to contact {name} {frequency} to improve your consistency.',
    beenAWhile: 'It\'s been a while! Reach out to {name} soon to reconnect and maintain your friendship.',
    startFriendshipJourney: 'Start your friendship journey by making your first contact with {name}!',
    recentActivity: 'Recent Activity',
    cadenceDescription: 'Your streak counts each time you contact {name} within your target frequency of {frequency}. Keep it going!',
    streakHint: 'Meets frequency',
    streakExplanation: 'Your streak increases each time you contact within the {frequency} target. Missing the target resets the streak.',
    
    // Streak Calendar
    yourStreak: 'Your Streak',
    streakActivities: 'Streak Activities',
    longestStreakEver: 'Longest Streak Ever',
    weeksUnit: 'Weeks',
    weekStreakMet: 'Week streak met',
    weekStreakMissed: 'Week streak missed',
    periodStreakMet: 'Period streak met',
    periodStreakMissed: 'Period streak missed',
    totalStreakWeeks: 'Total streak: {count} weeks',
    totalStreakPeriods: 'Total streak: {count} periods',
    daysUntilStreakBreaks: 'Days Until Streak Breaks',
    lastDayToMaintainStreak: 'Last day to maintain your streak!',
    // Milestone Tracker (shown on interaction history page)
    milestoneAchieved: 'Milestone Achieved!',
    achievedMilestones: 'Achieved Milestones',
    noMilestonesYet: 'No milestones achieved yet. Start connecting to unlock your first milestone! 🌱',
    achieved: 'Achieved',
    nextMilestones: 'Next Milestones',
    milestoneFirstContact: 'First Contact',
    milestoneFirstContactDesc: 'Made your first contact with this friend',
    milestoneWeekStrong: 'One Week Strong',
    milestoneWeekStrongDesc: 'Maintained contact for one week',
    milestoneMonthlyChampion: 'Monthly Champion',
    milestoneMonthlyChampionDesc: 'Consistent contact for one month',
    milestoneDeepConnection: 'Deep Connection',
    milestoneDeepConnectionDesc: 'Had a meaningful conversation',
    milestoneRitualMaster: 'Ritual Master',
    milestoneRitualMasterDesc: 'Established a friendship ritual',
    milestoneJourneyComplete: 'Journey Complete',
    milestoneJourneyCompleteDesc: 'Completed a friendship journey',
    // Contact Type Values
    contactTypeCall: 'Call',
    contactTypeEmail: 'Email',
    contactTypeText: 'Text',
    contactTypeVideo: 'Video',
    contactTypeMeeting: 'Meeting',
    contactTypeOther: 'Other',
    
    // Friendship Needs Assessment
    discoverYourFriendshipNeeds: 'Discover Your Friendship Needs',
    assessmentIntro: 'This assessment will help you understand what you truly need from your friendships. By answering a few questions, you\'ll get insights into:',
    idealFriendshipStyle: 'Your ideal friendship style and depth',
    socialInteractionEnergy: 'How much social interaction energizes you',
    supportValue: 'What kind of support you value most',
    communicationPreferences: 'Your communication preferences',
    realisticGoals: 'Realistic goals for your friendships',
    answersHelpSetGoals: 'Your answers will help you set meaningful goals and track your progress toward "friendship success" - whatever that means for you.',
    startAssessment: 'Start Assessment',
    retakeAssessment: 'Retake Assessment',
    question: 'Question',
    of: 'of',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
    yourFriendshipProfile: 'Your Friendship Needs & Style Profile',
    basedOnYourAnswers: 'Based on your answers, here\'s your friendship needs profile:',
    recommendations: 'Design Principles',
    setYourGoals: 'Set Your Goals',
    viewGoals: 'View Goals',
    yourTopPriorities: 'Your Top Priorities',
    // Need names
    needEmotional: 'Emotional',
    needSocial: 'Social',
    needFrequency: 'Frequency',
    needSupport: 'Support',
    needPractical: 'Practical',
    needCommunication: 'Communication',
    needGrowth: 'Growth',
    needFun: 'Fun',
    needDepth: 'Depth',
    needTime: 'Time',
    needRepair: 'Repair',
    // Need descriptions
    needDescriptionEmotional: 'You value emotional closeness and vulnerability in friendships. People with this profile feel most fulfilled when friendships include honesty, emotional safety, and mutual support.',
    needDescriptionSocial: 'You value social connection and shared experiences in friendships. People with this profile feel most fulfilled when friendships include regular social activities, group interactions, and a sense of belonging.',
    needDescriptionFrequency: 'You value consistent contact and regular connection in friendships. People with this profile feel most fulfilled when friendships include frequent check-ins, reliable communication, and ongoing presence in each other\'s lives.',
    needDescriptionSupport: 'You value mutual support and being there for each other in friendships. People with this profile feel most fulfilled when friendships include reliable help during challenges, emotional availability, and reciprocal care.',
    needDescriptionPractical: 'You value practical help and shared activities in friendships. People with this profile feel most fulfilled when friendships include doing things together, tangible assistance, and collaborative experiences.',
    needDescriptionCommunication: 'You value open and honest communication in friendships. People with this profile feel most fulfilled when friendships include clear dialogue, transparency, and direct expression of thoughts and feelings.',
    needDescriptionGrowth: 'You value personal growth and learning in friendships. People with this profile feel most fulfilled when friendships include shared learning experiences, mutual inspiration, and opportunities for development.',
    needDescriptionFun: 'You value fun and lighthearted moments in friendships. People with this profile feel most fulfilled when friendships include shared laughter, enjoyable activities, and positive energy.',
    needDescriptionDepth: 'You value depth and meaningful connection in friendships. People with this profile feel most fulfilled when friendships include profound conversations, genuine understanding, and quality over quantity.',
    needDescriptionTime: 'You value investing time and energy in friendships. People with this profile feel most fulfilled when friendships include regular time together, consistent presence, and meaningful time investment.',
    needDescriptionRepair: 'You value addressing conflicts and repairing relationships when things go wrong. People with this profile feel most fulfilled when friendships include open communication about issues, willingness to work through problems, and established repair rituals.',
    needDescriptionDefault: 'An important aspect of your friendship needs',
    // Design Principles
    recommendationEmotional: 'Design friendships around deeper connections',
    recommendationFrequency: 'Choose consistency over intensity',
    recommendationSocial: 'Prioritize shared experiences and regular connection',
    recommendationSupport: 'Be explicit about support needs early',
    recommendationDepth: 'Design friendships around deeper connections',
    recommendationRepair: 'Build repair rituals, not perfect harmony',
    recommendationQuantityFew: 'Aim for 2-4 close friendships where you can invest deeply',
    recommendationQuantityModerate: 'Aim for 5-8 close friendships for a balanced social circle',
    recommendationQuantityMany: 'Aim for 9+ friendships to build a diverse social network',
    recommendationDefault1: 'Build balanced friendships that adapt to different needs',
    recommendationDefault2: 'Choose consistency over intensity',
    suggestedGoalsBasedOnAssessment: '💡 Suggested Goals Based on Your Assessment',
    clickRecommendationToAddGoal: 'Click any principle to add it as a goal',
    progressOverview: 'Progress Overview',
    completed: 'Completed',
    totalGoals: 'Total Goals',
    progress: 'Progress',
    noGoalsYet: 'No goals yet. Add your first goal above!',
    goalInputPlaceholder: 'E.g., Have weekly check-ins with 3 close friends',
    addGoal: 'Add Goal',
    goalText: 'Goal text',
    saveGoals: 'Save Goals',
    skipForNow: 'Skip for Now',
    yourKeyTargets: 'Your key friendship targets',
    summaryEmotionalDepth: 'You prefer your close friendships to feel: {depth}',
    summaryCloseFriendsQuantity: 'You want to maintain around {target} close friends.',
    summaryQuantityRealismNote: 'Given your current time and energy, this might be a stretch — we can always adjust later.',
    goalsAnchoredInTargets: 'Goals anchored in what you said you want',
    goalsAnchoredInTargetsHelp: 'These goals are based on the emotional depth and number of close friends you chose in the assessment.',
    autoGoalCloseFriendsCount: 'Build and maintain about {target} close friendships.',
    autoGoalEmotionalDepth: 'Prioritize friendships that feel {depth} to you.',
    progressTowardGoals: 'Your Progress Toward Goals',
    closeFriendsProgress: 'Close Friends Goal',
    closeFriendsRemaining: 'You need {count} more close friend(s) to reach your goal.',
    closeFriendsGoalReached: '🎉 You\'ve reached your close friends goal!',
    emotionalDepthProgress: 'Emotional Depth Goal',
    emotionalDepthHasFriends: 'You have {count} close friend(s) to develop {level} connections with.',
    emotionalDepthNoFriends: 'Start by adding close friends to work toward your emotional depth goal.',
    addCloseFriends: 'Add Close Friends',
    nurtureFriendships: 'Nurture Friendships',
    todaysFriendshipAction: 'Today\'s Friendship Action',
    whyThisMatters: 'Why this matters',
    howToDoIt: 'How to do it',
    effortLevel: 'Effort level:',
    
    // Additional keys
    notStarted: 'Not Started',
    totalJourneys: 'Total Journeys',
    noJourneysFound: 'No journeys found',
    noJourneysYet: "You haven't started any friendship journeys yet. Visit the Friendship Tracker to start your first journey!",
    noActiveJourneys: "You don't have any active journeys right now.",
    noCompletedJourneys: "You haven't completed any journeys yet.",
    goToFriendshipTracker: 'Go to Friendship Tracker',
    inProgress: 'In Progress',
    allJourneys: 'All Journeys',
    
    // Footer
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms and Conditions',
  },
  
  da: {
    // App header
    appName: 'Ups & Downs',
    dashboard: 'Dashboard',
    friendships: 'Venskaber',
    journeys: 'Rejser',
    friendshipGoals: 'Venskabsmål',
    signIn: 'Log ind',
    getStarted: 'Kom i gang',
    
    // Auth
    welcomeBack: 'Velkommen tilbage',
    joinNow: 'Tilmeld dig nu',
    signInDescription: 'Log ind for at fortsætte med at bygge stærke venskaber',
    signUpDescription: 'Begynd at bygge tættere venskaber i dag',
    yourName: 'Dit navn',
    enterYourName: 'Indtast dit navn',
    email: 'E-mail',
    enterYourEmail: 'Indtast din e-mail',
    password: 'Adgangskode',
    enterYourPassword: 'Indtast din adgangskode',
    pleaseWait: 'Vent venligst...',
    signInButton: 'Log ind',
    createAccount: 'Opret konto',
    forgotPassword: 'Glemt din adgangskode?',
    enterEmailForReset: 'Indtast din e-mail ovenfor, og klik derefter på "Glemt din adgangskode?"',
    passwordResetEmailSent: 'E-mail til nulstilling af adgangskode er sendt. Tjek din indbakke.',
    dontHaveAccount: 'Har du ikke en konto? ',
    alreadyHaveAccount: 'Har du allerede en konto? ',
    signUp: 'Tilmeld dig',
    signInLink: 'Log ind',
    agreeToTerms: 'Ved tilmelding accepterer du vores',
    termsAndConditions: 'Vilkår og betingelser',
    and: 'og',
    privacyPolicy: 'Fortrolighedspolitik',
    
    // Auth errors
    fillAllFields: 'Udfyld venligst alle felter',
    enterName: 'Indtast venligst dit navn',
    acceptTermsRequired: 'Accepter venligst Vilkårene og betingelserne og Fortrolighedspolitikken for at fortsætte',
    emailAlreadyInUse: 'Der findes allerede en konto med denne e-mail',
    invalidEmail: 'Ugyldig e-mailadresse',
    weakPassword: 'Adgangskoden skal være mindst 6 tegn',
    userNotFound: 'Ingen konto fundet med denne e-mail',
    wrongPassword: 'Forkert adgangskode',
    tooManyRequests: 'For mange mislykkede forsøg. Prøv igen senere',
    networkError: 'Netværksfejl. Tjek din forbindelse og prøv igen',
    authNotEnabled: 'E-mail/adgangskode-godkendelse er ikke aktiveret. Kontakt venligst support',
    userDisabled: 'Denne konto er blevet deaktiveret. Kontakt venligst support',
    signInFailed: 'Kunne ikke logge ind. Prøv igen',
    
    // User profile
    user: 'Bruger',
    subscription: 'Abonnement',
    signOut: 'Log ud',
    
    // Dashboard
    welcomeBackDashboard: 'Velkommen tilbage! 👋',
    dashboardSubtitle: 'Her er hvad der sker med dine venskaber',
    totalFriends: 'Samlede venner',
    needAttention: 'Kræver opmærksomhed',
    allGood: 'Alt godt',
    daysSinceLastInteraction: 'Dage siden sidste interaktion',
    yourFriendshipGoals: 'Dine venskabsmål',
    manageGoals: 'Administrer mål',
    goalsCompleted: 'mål fuldført',
    of: 'af',
    moreGoals: 'flere mål',
    moreGoalsPlural: 'flere mål',
    discoverFriendshipNeeds: 'Opdag dine venskabsbehov',
    takeAssessmentDescription: 'Tag vores hurtige vurdering for at forstå, hvad du har brug for fra venskaber, og sæt mål for at spore din fremgang mod venskabssucces.',
    takeAssessment: 'Tag vurdering',
    quickActions: 'Hurtige handlinger',
    manageFriendships: 'Administrer venskaber',
    startJourney: 'Start rejse',
    myFriendshipNeeds: 'Mine venskabsbehov',
    friendshipHealth: 'Venskabshelbred',
    viewAll: 'Se alle',
    noFriendsYet: 'Ingen venner endnu',
    noFriendsDescription: 'Begynd at bygge dit venskabsnetværk ved at tilføje din første ven!',
    addFirstFriend: 'Tilføj din første ven',
    recentInteractions: 'Seneste interaktioner',
    loadingDashboard: 'Indlæser dit dashboard...',
    never: 'Aldrig',
    today: 'I dag',
    dayAgo: 'dag siden',
    daysAgo: 'dage siden',
    monthAgo: 'måned siden',
    monthsAgo: 'måneder siden',
    moreThanMonthAgo: 'mere end 1 måned siden',
    moreThanMonthsAgo: 'mere end {count} måneder siden',
    lastContact: 'Sidste kontakt:',
    timeToTakeAction: 'Tid til at handle',
    allCaughtUp: 'Alt er opdateret! Ingen venner kræver opmærksomhed lige nu.',
    allGoodCategory: 'Alt godt',
    noFriendsInCategory: 'Ingen venner i denne kategori endnu.',
    
    // Friendship Tracker
    friendshipTracker: 'Venskabssporing',
    trackerSubtitle: 'Hold dine relationer stærke ved at holde kontakten',
    friends: 'Venner',
    healthyRelationships: 'Sunde relationer',
    timeToTakeActionTracker: 'Tid til at handle',
    needAttentionTracker: 'Kræver opmærksomhed',
    addFriend: 'Tilføj ven',
    back: 'Tilbage',
    addNewFriend: 'Tilføj ny ven',
    name: 'Navn',
    nameRequired: 'Navn *',
    friendsName: 'Vennens navn',
    relationship: 'Forhold',
    contactFrequency: 'Kontaktfrekvens',
    phone: 'Telefon',
    phoneNumber: 'Telefonnummer',
    emailAddress: 'E-mailadresse',
    lastContactDate: 'Sidste kontaktdato',
    notes: 'Noter',
    notesPlaceholder: 'Eventuelle noter om dette venskab...',
    save: 'Gem',
    cancel: 'Annuller',
    delete: 'Slet',
    edit: 'Rediger',
    close: 'Luk',
    yes: 'Ja',
    no: 'Nej',
    countsAsCloseFriend: 'Tæller som nær ven',
    countsAsCloseFriendHint: 'Marker denne ven som tæller med i dit mål for nære venner, uanset venskabstype',
    
    // Contact types
    call: 'Opkald',
    email: 'E-mail',
    text: 'Besked',
    meeting: 'Møde',
    video: 'Videoopkald',
    lunch: 'Frokost',
    dinner: 'Middag',
    coffee: 'Kaffe',
    activity: 'Aktivitet',
    
    // Contact frequency
    daily: 'Dagligt',
    weekly: 'Ugentligt',
    biweekly: 'Hver anden uge',
    monthly: 'Månedligt',
    quarterly: 'Kvartalsvis',
    
    // Relationship types
    friend: 'Ven',
    bestFriend: 'Bedste ven',
    colleague: 'Kollega',
    family: 'Familie',
    acquaintance: 'Bekendt',
    mentor: 'Mentor',
    neighbor: 'Nabo',
    
    // Status messages
    allGoodStatus: 'Alt godt!',
    timeToReachOut: 'Tid til at kontakte',
    needsAttentionStatus: 'Kræver opmærksomhed',
    
    // Premium
    upgradeToPremium: '🚀 Opgrader til Premium',
    friendLimitReached: 'Du har nået den gratis grænse på 1 ven. Opgrader til Premium for at tilføje ubegrænsede venner!',
    journeyAccess: 'Rejser er en Premium-funktion. Opgrader for at låse op for vejledede venskabsrejser!',
    upgradeGeneral: 'Opgrader til Premium for at låse op for alle funktioner og ubegrænsede venner!',
    premiumFeatures: 'Premium-funktioner:',
    unlimitedFriends: 'Ubegrænsede venner',
    guidedJourneys: 'Vejledede venskabsrejser',
    advancedTracking: 'Avanceret sporing og analyse',
    cancelAnytime: 'Opsig når som helst',
    upgradeNow: 'Opgrader nu',
    maybeLater: 'Måske senere',
    processing: 'Behandler...',
    paymentSystemNotAvailable: 'Betalingssystem ikke tilgængeligt. Prøv igen senere.',
    paymentFailed: 'Betaling mislykkedes: {message}',
    failedToStartPayment: 'Kunne ikke starte betaling: {message}',
    
    // Payment messages
    paymentSuccessful: '🎉 Betaling gennemført! Du har nu premium-adgang.',
    paymentCancelled: 'Betaling annulleret. Du kan prøve igen når som helst.',
    
    // Simple Friends List
    friendshipOverview: 'Venskabsoversigt',
    quickGlance: 'Hurtigt overblik over sundheden i dine venskaber',
    signInToSeeFriends: 'Log ind for at se dine venner og sidste forbindelser.',
    loading: 'Indlæser…',
    noFriendsYetTracker: 'Ingen venner endnu. Tilføj nogle i sporingen.',
    
    // Feature Cards
    readyToTransform: 'Klar til at transformere dine venskaber?',
    joinToday: 'Tilmeld dig i dag, hvis du er klar til at forbedre dine sociale forbindelser',
    
    // Common
    lastConnected: 'Sidste forbundet ·',
    
    // Language switcher
    language: 'Sprog',
    english: 'Engelsk',
    danish: 'Dansk',
    
    // Friendship Tracker - Additional
    appointments: 'Aftaler',
    contactHistory: 'Kontakthistorik',
    scheduleAppointment: 'Planlæg aftale',
    noFriendsTrackedYet: 'Ingen venner sporet endnu',
    addFirstFriendToStart: 'Tilføj din første ven for at begynde at spore dine relationer!',
    addFriendWithLimit: 'Tilføj ven ({count}/1)',
    initialGoalsOptional: 'Indledende mål (valgfrit)',
    goalTitlePlaceholder: 'Måltitel (f.eks. Mød oftere)',
    addAnotherGoal: 'Tilføj endnu et mål',
    removeLastGoal: 'Fjern sidste mål',
    currentGoals: 'Nuværende mål:',
    canAddMultipleGoals: 'Du kan tilføje flere mål og redigere dem senere i venskabssporingen.',
    manageGoals: 'Administrer mål',
    setGoals: 'Sæt mål',
    editNotes: 'Rediger noter',
    removeFriend: 'Fjern ven',
    recordContact: 'Registrer kontakt',
    viewDetails: 'Se detaljer',
    startJourney: 'Start rejse',
    selectFriendshipType: 'Vælg venskabstype',
    daysSince: 'dage siden',
    lastContacted: 'sidst kontaktet',
    contactFrequencyLabel: 'Kontaktfrekvens:',
    noNotesYet: 'Ingen noter endnu',
    noGoalsYet: 'Ingen mål sat endnu',
    addGoal: 'Tilføj mål',
    goalTitle: 'Måltitel',
    goalDescription: 'Beskrivelse',
    goalCategory: 'Kategori',
    targetDate: 'Måldato',
    connection: 'Forbindelse',
    communication: 'Kommunikation',
    funActivities: 'Sjov og aktiviteter',
    support: 'Støtte',
    personalGrowth: 'Personlig vækst',
    other: 'Andet',
    
    // Friend Profile
    friendProfile: 'Venprofil',
    backToHome: 'Tilbage til start',
    birthday: 'Fødselsdag',
    editBirthday: 'Rediger fødselsdag',
    saveBirthday: 'Gem fødselsdag',
    upcomingAppointments: 'Kommende aftaler',
    noUpcomingAppointments: 'Ingen kommende aftaler',
    pastInteractions: 'Tidligere interaktioner',
    noPastInteractions: 'Ingen tidligere interaktioner endnu',
    goals: 'Mål',
    friendshipType: 'Venskabstype',
    editProfile: 'Rediger profil',
    showInteractionHistory: 'Vis interaktionshistorik',
    interactionHistory: 'Interaktionshistorik',
    interaction: 'interaktion',
    interactions: 'interaktioner',
    reflectionEvaluation: 'Reflektionsevaluering',
    logInteraction: 'Registrer interaktion',
    setGoalsForFriend: 'Sæt mål for ven',
    notesOnFriend: 'Noter om ven',
    selectFriendshipTypeModal: 'Vælg venskabstype',
    friendshipNeedsAssessment: 'Venskabsbehovsvurdering',
    friendshipNeedsAssessmentQuestionnaire: 'Venskabsbehovsvurderingsspørgeskema',
    startNewJourneyModal: 'Start ny rejse',
    noContactHistoryYet: 'Ingen kontakthistorik endnu',
    startReachingOut: 'Begynd at kontakte venner for at opbygge din kontakthistorik!',
    goalsFor: 'Mål for',
    lastInteraction: 'Sidste interaktion',
    typeOfFriendship: 'Type af venskab',
    nextAppointment: 'Næste aftale',
    friendshipOverviewTitle: 'Venskabsoversigt',
    with: 'med',
    for: 'for',
    to: 'til',
    howWasConversation: 'Hvordan var samtalen?',
    topicsDiscussed: 'Emner diskuteret',
    highlights: 'Højdepunkter',
    nextSteps: 'Næste skridt',
    currentGoals: 'Nuværende mål',
    selectCategory: 'Vælg en kategori',
    targetDateOptional: 'Måldato (valgfrit)',
    loadingFriendProfile: 'Indlæser venprofil...',
    friendNotFound: 'Ven ikke fundet',
    overallReflection: 'Samlet reflektion',
    notProvided: 'Ikke angivet',
    
    // Reflection Prompt (Quick Reflection)
    quickReflection: 'Hurtig reflektion',
    howWasYourContact: 'Hvordan var dit {contactType} med {name}?',
    // Step titles
    stepTitleHowWasConversation: 'Hvordan var jeres samtale?',
    stepTitleWhatDidYouTalkAbout: 'Hvad talte I om?',
    stepTitleWhatWereHighlights: 'Hvad var højdepunkterne?',
    stepTitleAnyNextSteps: 'Nogen næste skridt?',
    stepTitleOverallReflection: 'Samlet reflektion',
    // Step descriptions
    stepDescRateConversation: 'Bedøm hvordan samtalen gik overordnet',
    stepDescSelectTopics: 'Vælg de vigtigste emner I diskuterede',
    stepDescBestMoments: 'Hvad var de bedste øjeblikke eller mest meningsfulde dele? (Valgfrit)',
    stepDescPlansCommitments: 'Lavede I nogen planer eller forpligtelser? (Valgfrit)',
    stepDescFinalThoughts: 'Nogen sidste tanker om denne interaktion? (Valgfrit)',
    // Mood options
    moodExcellent: 'Fremragende',
    moodGood: 'God',
    moodOkay: 'Okay',
    moodDifficult: 'Svært',
    // Topic options
    topicWorkCareer: 'Arbejde & Karriere',
    topicFamilyRelationships: 'Familie & Relationer',
    topicHealthWellness: 'Sundhed & Velvære',
    topicHobbiesInterests: 'Hobbyer & Interesser',
    topicTravelAdventures: 'Rejser & Eventyr',
    topicGoalsDreams: 'Mål & Drømme',
    topicChallengesStruggles: 'Udfordringer & Kampe',
    topicCelebrationsAchievements: 'Fejringer & Præstationer',
    topicCurrentEvents: 'Aktuelle Begivenheder',
    topicMemoriesNostalgia: 'Minder & Nostalgi',
    topicFuturePlans: 'Fremtidige Planer',
    topicOther: 'Andet',
    // Placeholders
    pleaseSpecify: 'Angiv venligst...',
    placeholderHighlights: 'Hvad var de bedste øjeblikke? Hvad fik dig til at smile eller føle forbundethed?',
    placeholderNextSteps: 'Lavede I nogen planer? Sætte nogen mål? Lover at gøre noget sammen?',
    placeholderOverall: 'Nogen sidste tanker? Hvordan føler du dig om dit venskab lige nu?',
    // Buttons
    back: 'Tilbage',
    next: 'Næste',
    saveReflection: 'Gem reflektion',
    
    // Schedule Appointment Modal
    scheduleAppointmentTitle: 'Planlæg aftale',
    upcomingAppointments: 'Kommende aftaler',
    friendLabel: 'Ven',
    titleLabel: 'Titel *',
    titlePlaceholder: 'f.eks. Kaffemøde, Middag, Opkald',
    dateLabel: 'Dato *',
    timeLabel: 'Tid *',
    typeLabel: 'Type',
    appointmentTypeMeeting: 'Personligt møde',
    appointmentTypeCall: 'Telefonopkald',
    appointmentTypeVideo: 'Videoopkald',
    appointmentTypeLunch: 'Frokost',
    appointmentTypeDinner: 'Middag',
    appointmentTypeCoffee: 'Kaffe',
    appointmentTypeActivity: 'Aktivitet',
    appointmentTypeOther: 'Andet',
    locationLabel: 'Sted',
    locationPlaceholder: 'Hvor mødes I?',
    notesLabel: 'Noter',
    notesPlaceholderAppointment: 'Eventuelle yderligere noter om denne aftale...',
    confirmDeleteAppointment: 'Er du sikker på, at du vil slette denne aftale?',
    
    // Set Goals Modal
    goalTitleLabel: 'Måltitel *',
    goalTitlePlaceholder: 'f.eks. Mødes oftere, Have dybere samtaler',
    goalDescriptionLabel: 'Beskrivelse',
    goalDescriptionPlaceholder: 'Beskriv hvad du vil opnå...',
    goalCategoryLabel: 'Kategori *',
    goalCategoryConnection: 'Forbindelse',
    goalCategoryCommunication: 'Kommunikation',
    goalCategoryFun: 'Sjov & Aktiviteter',
    goalCategorySupport: 'Støtte',
    goalCategoryGrowth: 'Personlig vækst',
    goalCategoryOther: 'Andet',
    targetLabel: 'Mål:',
    addGoal: 'Tilføj mål',
    
    // Journeys
    reconnectAndDeepen: 'Genopret og uddyb dit venskab',
    journeyDescription: 'En 4-ugers online selvstyret, videnskabsbaseret rejse til at genopbygge nærvær gennem små, meningsfulde øjeblikke — uden akavethed eller overinvestering.',
    weeks: 'uger',
    activities: 'aktiviteter',
    all: 'Alle',
    active: 'Aktiv',
    completed: 'Fuldført',
    startJourneyWith: 'Start rejse med',
    selectFriend: 'Vælg ven',
    noFriendsForJourney: 'Ingen venner tilgængelige. Tilføj en ven først!',
    journeyProgress: 'Rejsefremskridt',
    week: 'Uge',
    completedActivities: 'fuldført',
    ofActivities: 'af',
    backToJourneys: 'Tilbage til rejser',
    overview: 'Oversigt',
    // Journey Objectives
    objectiveReachOut: 'Kontakt med selvtillid og selvrespekt',
    objectiveBuildRhythms: 'Byg bæredygtige venskabsrytmer, der passer til voksenlivet',
    objectiveDeepenConnection: 'Uddyb følelsesmæssig forbindelse sikkert og gensidigt',
    // Journey Overview
    loadingPersonalizedJourney: 'Indlæser din personlige rejse...',
    personalizationForYou: 'Tilpasset til dig',
    personalizationRefresh: 'Opdater ud fra mine refleksioner',
    personalizationUpdating: 'Opdaterer…',
    personalizationNeedReflections: 'Skriv en refleksion i en uge, og tryk derefter opdater for at tilpasse oversigten til det, du har delt.',
    personalizationThemesHeading: 'Temaer vi bemærkede',
    personalizationEmptyError: 'Der kom ingen tilpasning tilbage. Prøv igen.',
    personalizationGenericError: 'Noget gik galt. Prøv igen om lidt.',
    overallProgress: 'Samlet fremskridt',
    activitiesCompleted: 'aktiviteter fuldført',
    journeyObjectives: 'Rejsemål',
    your4WeekJourney: 'Din 4-ugers rejse',
    startWeek: 'Start uge',
    completeWeekFirst: 'Fuldfør uge {week} først',
    journeyComplete: '🎉 Rejse fuldført!',
    journeyCompleteMessage: 'Tillykke! Du har fuldført alle {total} aktiviteter gennem alle 4 uger. Fortsæt med at pleje dit venskab og byg videre på de forbindelser, du har skabt.',
    reviewJourney: 'Gennemgå rejse',
    continueYourJourney: 'Fortsæt din rejse',
    continueWeek: 'Fortsæt {weekTitle}',
    completeWeekFirstMessage: 'Fuldfør alle aktiviteter i {week} for at låse {nextWeek} op.',
    goToWeek: 'Gå til {week}',
    readyToBegin: 'Klar til at begynde?',
    readyToBeginMessage: 'Start med uge 1 for at begynde din rejse mod dybere, mere meningsfulde venskaber.',
    beginWeek1: 'Begynd uge 1: Forbered og kontakt',
    // Week Titles
    week1Title: 'Uge 1: Forbered og kontakt',
    week2Title: 'Uge 2: Genopbyg rytme',
    week3Title: 'Uge 3: Uddyb med samtykke',
    week4Title: 'Uge 4: Fastgør det',
    // Week Focuses
    week1Focus: 'Vælg det rigtige venskab, sæt sunde forventninger, og send én grundet genforbindelsesbesked',
    week1FocusWithFriend: 'Vælg det rigtige venskab, sæt sunde forventninger, og send én grundet genforbindelsesbesked til {name}',
    week2Focus: 'Skab en let, bæredygtig rytme - uden at forfølge eller overinvestere',
    week2FocusWithFriend: 'Skab en let, bæredygtig rytme med {name} - uden at forfølge eller overinvestere',
    week3Focus: 'Øg følelsesmæssig dybde kun hvor sikkerhed og gensidighed eksisterer',
    week3FocusWithFriend: 'Øg følelsesmæssig dybde med {name} kun hvor sikkerhed og gensidighed eksisterer',
    week4Focus: 'Skab strukturer, der overlever det virkelige liv',
    week4FocusWithFriend: 'Skab strukturer med {name} der overlever det virkelige liv',
    // Week Activities
    activityFriendshipFit: 'Venskabspasning og sikkerhedstjek',
    activityFriendshipFitWithFriend: 'Venskabspasning og sikkerhedstjek med {name}',
    activityClarifyIntention: 'Klar dit formål',
    activityCraftMessage: 'Skab og send beskeden',
    activityReadResponse: 'Læs svaret klart',
    activityReadResponseWithFriend: 'Læs svaret klart fra {name}',
    activityMicroConnection: 'Skab én mikroforbindelse',
    activityBalanceCheck: 'Forbindelsesbalancecheck',
    activityGoDeeper: 'Gå et niveau dybere',
    activityGoDeeperWithFriend: 'Gå et niveau dybere med {name}',
    activityShareTruth: 'Del en lille, ægte sandhed',
    activityDeepListening: 'Øv dyb lytning',
    activityDesignRitual: 'Design en venskabsritual',
    activityDesignRitualWithFriend: 'Design en venskabsritual med {name}',
    activityRestartRule: 'Opret en genstartregel',
    activityFinalIntegration: 'Endelig integration og fejring',
    // Week Completion Messages
    completeWeek1Start2: 'Fuldfør uge 1 → Start uge 2',
    completeWeek2Start3: 'Fuldfør uge 2 → Start uge 3',
    completeWeek3Start4: 'Fuldfør uge 3 → Start uge 4',
    congratulationsJourneyComplete: '🎉 Tillykke! Du har fuldført 4-ugers rejsen!',
    // Start Journey Modal
    step1ChooseJourneyType: 'Trin 1: Vælg rejsetype',
    step2ChooseFriend: 'Trin 2: Vælg ven',
    noFriendsForJourneyMessage: 'Du har ingen venner endnu. Tilføj venner i Venskabssporing først.',
    goToFriendshipTrackerButton: 'Gå til Venskabssporing',
    existingJourney: 'eksisterende rejse',
    existingJourneys: 'eksisterende rejser',
    startJourney: 'Start rejse',
    quickActions: 'Hurtige handlinger',
    // Assessment Questions - Categories
    categoryConnectionDepth: 'Forbindelsesdybde',
    categorySocialEnergy: 'Social energi',
    categorySupportNeeds: 'Støttebehov',
    categoryCommunication: 'Kommunikation',
    categoryGoals: 'Mål',
    categorySocialCircle: 'Sociale kreds',
    categoryTimeInvestment: 'Tidsinvestering',
    categoryConflictBoundaries: 'Reaktion på brud',
    categoryRepairStyle: 'Reparationsstil',
    categoryInitiationBalance: 'Initieringsbalance',
    // Assessment Questions
    questionConnectionDepth: 'Hvilket niveau af følelsesmæssig dybde vil du have de fleste af dine nære venskaber?',
    questionSocialEnergy: 'Hvor meget giver social interaktion dig energi? Der er ikke noget rigtigt svar — det handler om, hvordan du bedst oplader.',
    questionSupportType: 'Når livet er udfordrende, hvad ønsker du mest fra nære venner?',
    questionCommunicationStyle: 'Hvilket kontaktniveau hjælper dig med at føle dig forbundet uden at føle dig overvældet?',
    questionFriendshipGoals: 'Hvilken rolle vil du mest have, at venskaber skal spille i dit liv lige nu?',
    questionFriendshipQuantity: 'Hvor mange nære venskaber vil du vedligeholde? Kvalitet og kvantitet betyder begge noget — dette hjælper os med at forstå din præference.',
    questionTimeInvestment: 'Hvor meget tid og energi kan du realistisk investere i venskaber de fleste uger?',
    questionConflictHandling: 'Når noget føles forkert i et venskab, hvad gør du normalt først?',
    questionRepairStyle: 'Efter en misforståelse, hvad hjælper dig med at føle dig tæt igen?',
    questionInitiationBalance: 'I de fleste venskaber, hvem initierer normalt kontakten?',
    // Assessment Options - Connection Depth
    optionDeep: 'Dybe, følelsesmæssigt åbne forbindelser hvor vi deler rigtige udfordringer',
    optionBalanced: 'En blanding af dybe samtaler og lettere, sjov forbindelse',
    optionCasual: 'For det meste lette, positive venskaber med lejlighedsvise dybder',
    // Assessment Options - Social Energy
    optionHigh: 'Jeg trives med hyppig social interaktion',
    optionModerate: 'Jeg nyder regelmæssig social tid, men har brug for balance',
    optionLow: 'Jeg foretrækker mindre hyppige men kvalitetsinteraktioner',
    // Assessment Options - Support Type
    optionEmotional: 'Følelsesmæssig forståelse og at blive hørt',
    optionPractical: 'Praktisk hjælp og at gøre ting sammen',
    optionBoth: 'En balance mellem følelsesmæssig og praktisk støtte',
    // Assessment Options - Communication Style
    optionFrequent: 'Hyppige tjek-ins (dagligt eller flere gange om ugen)',
    optionRegular: 'Regelmæssig kontakt (ugentligt eller hver anden uge)',
    optionOccasional: 'Lejlighedsvis men meningsfuld kontakt (månedligt eller efter behov)',
    // Assessment Options - Friendship Goals
    optionGrowth: 'Personlig vækst og læring sammen',
    optionFun: 'At have det sjovt og dele oplevelser',
    optionSupport: 'Gensidig støtte gennem livets udfordringer',
    optionAll: 'En balanceret blanding, der tilpasser sig forskellige livsfaser',
    // Assessment Options - Friendship Quantity
    optionFew: 'Et par meget nære venner (2-4)',
    optionModerateCircle: 'En moderat kreds (5-8 nære venner)',
    optionMany: 'En større social kreds (9+ venner)',
    // Assessment Options - Time Investment
    optionHighTime: 'Jeg kan investere betydelig tid regelmæssigt',
    optionModerateTime: 'Jeg kan investere moderat tid med lidt planlægning',
    optionLimited: 'Jeg har begrænset tid, så kvalitet over kvantitet',
    // Assessment Options - Conflict Handling
    optionDirect: 'Bring det op direkte og tal det igennem',
    optionGentle: 'Sid med det og adresser det blidt senere',
    optionAvoid: 'Trække sig tilbage og se om det løser sig af sig selv',
    // Assessment Options - Repair Style
    optionTalkThrough: 'At tale det igennem åbent',
    optionApologyBehavior: 'En oprigtig undskyldning og ændret adfærd',
    optionTimeNormal: 'Tid går og vender tilbage til normal',
    optionSharedExperiences: 'Delte positive oplevelser',
    // Assessment Options - Initiation Balance
    optionMostlyMe: 'For det meste mig',
    optionAboutEqual: 'Omkring lige',
    optionMostlyThem: 'For det meste dem',
    optionVaries: 'Det varierer meget',
    
    // Subscription Management
    subscriptionManagement: 'Abonnementsadministration',
    backToHome: 'Tilbage til start',
    currentStatus: 'Nuværende status',
    premium: 'Premium',
    free: 'Gratis',
    loadingSubscriptionInfo: 'Indlæser abonnementsinformation...',
    manageSubscription: 'Administrer abonnement',
    upgradeToPremium: 'Opgrader til Premium',
    unableToOpenPortal: 'Kan ikke åbne abonnementsadministration. ',
    portalNotConfigured: 'Kundeportalen er ikke konfigureret endnu. Kontakt venligst support.',
    noSubscriptionFound: 'Intet abonnement fundet. Opgrader venligst til premium først.',
    premiumFeatures: 'Premium-funktioner',
    deepeningRelationshipsJourney: 'Rejse til at uddybe relationer',
    journeyDescriptionShort: '4-ugers vejledet rejse til at styrke dine venskaber',
    friendshipTrackerFeature: 'Venskabssporing',
    friendshipTrackerDescription: 'Spor og administrer dine venskaber med detaljerede indsigter',
    syncSubscriptionStatus: 'Synkroniser dit abonnementsstatus fra Stripe',
    syncing: 'Synkroniserer...',
    syncStatus: '🔄 Synkroniser status',
    unlockPremiumFeatures: 'Lås alle premium-funktioner op for at få mest muligt ud af Ups & Downs:',
    yourCurrentAccess: 'Din nuværende adgang:',
    accessTo1Friend: '✅ Adgang til 1 ven (alle dine vensdata er bevaret)',
    journeysPaused: '❌ Rejser er sat på pause',
    cannotAddMoreFriends: '❌ Kan ikke tilføje flere venner',
    upgradeToRestoreAccess: 'Opgrader for at genoprette fuld adgang til alle venner og rejser!',
    joinOnlineJourneys: 'Deltag i online rejser for at styrke dine venskaber',
    accountInformation: 'Kontoinformation',
    emailLabel: 'E-mail:',
    userIdLabel: 'Bruger-ID:',
    memberSince: 'Medlem siden:',
    needHelp: 'Har du brug for hjælp?',
    supportMessage: 'Hvis du har spørgsmål om dit abonnement eller har brug for assistance, kontakt venligst vores supportteam.',
    checkSubscriptionStatus: 'Tjek om du har et aktivt abonnement',
    checkSubscriptionStatusButton: '🔄 Tjek abonnementsstatus',
    subscriptionStatusUpdated: 'Abonnementsstatus opdateret! Du har nu premium-adgang.',
    noActiveSubscription: 'Intet aktivt abonnement fundet. Hvis du lige har betalt, vent venligst et øjeblik og prøv igen.',
    failedToSyncStatus: 'Kunne ikke synkronisere abonnementsstatus: {message}',
    // Contact History
    duration: 'Varighed',
    durationLabel: 'Varighed:',
    allInteractions: 'Alle interaktioner',
    reload: '🔄 Genindlæs',
    noInteractionsRecorded: 'Ingen interaktioner registreret endnu',
    at: 'kl.',
    scheduled: '📅 Planlagt',
    completed: '✅ Fuldført',
    cancelled: '❌ Annulleret',
    // Contact Form
    contactType: 'Kontakttype',
    date: 'Dato',
    time: 'Tid',
    phoneCall: '📞 Telefonopkald',
    emailContact: '📧 E-mail',
    textMessage: '💬 Tekstbesked',
    videoCall: '📹 Videoopkald',
    inPersonMeeting: '🤝 Personligt møde',
    otherContact: '💭 Andet',
    durationPlaceholder: 'f.eks. 30 minutter, 1 time, 2 timer',
    notesPlaceholderContact: 'Hvad talte I om? Hvordan gik det?',
    plannedAppointment: 'Vi planlagde en ny aftale/møde',
    appointmentDetails: 'Aftaledetaljer',
    appointmentTitle: 'Aftaletitel',
    appointmentDate: 'Aftaledato',
    appointmentTime: 'Aftaletid',
    appointmentTitlePlaceholder: 'f.eks. Kaffemøde, Middag, Filmkvæld',
    deleteContactRecord: 'Er du sikker på, at du vil slette denne kontaktregistrering?',
    viewReflection: 'Se reflektion',
    // Interaction History Page
    activeJourneys: 'Aktive rejser',
    started: 'Startet:',
    activitiesCompletedCount: '{completed} af {total} aktiviteter fuldført ({percentage}%)',
    noAppointmentsScheduled: 'Ingen aftaler planlagt',
    today: 'I dag',
    yesterday: 'I går',
    daysAgoCount: '{count} dage siden',
    oneDayAgo: '1 dag siden',
    // Cadence Tracker (shown on interaction history page)
    interactionCadence: 'Interaktionsrytme',
    excellentCadence: 'Fremragende rytme!',
    goodConsistency: 'God konsistens',
    couldBeMoreConsistent: 'Kunne være mere konsistent',
    needsAttentionCadence: 'Kræver opmærksomhed',
    noDataYet: 'Ingen data endnu',
    currentStreak: 'Nuværende stime',
    bestStreak: 'Bedste stime',
    avgGap: 'Gns. interval',
    targetContact: 'Mål: {frequency} kontakt',
    lastContact: 'Sidste kontakt:',
    nextTarget: 'Næste mål:',
    notSet: 'Ikke sat',
    daysOverdue: '{count} dage for sent',
    daysLeft: '{count} dage tilbage',
    tipsForBetterCadence: 'Tips til bedre rytme',
    doingAmazing: 'Du klarer det fantastisk! Fortsæt med den store konsistens med {name}.',
    greatJob: 'Godt klaret! Prøv at vedligeholde denne rytme med {name} for at bygge en endnu stærkere forbindelse.',
    setReminder: 'Sæt en påmindelse om at kontakte {name} {frequency} for at forbedre din konsistens.',
    beenAWhile: 'Det er ved at være længe siden! Kontakt {name} snart for at genoprette forbindelsen og vedligeholde dit venskab.',
    startFriendshipJourney: 'Start din venskabsrejse ved at foretage din første kontakt med {name}!',
    recentActivity: 'Seneste aktivitet',
    cadenceDescription: 'Din stime tæller hver gang du kontakter {name} inden for dit mål på {frequency}. Fortsæt det gode arbejde!',
    streakHint: 'Opfylder frekvens',
    streakExplanation: 'Din stime stiger hver gang du kontakter inden for {frequency} målet. At misser målet nulstiller stimen.',
    
    // Streak Calendar
    yourStreak: 'Din stime',
    streakActivities: 'Stimeaktiviteter',
    longestStreakEver: 'Længste stime nogensinde',
    weeksUnit: 'Uger',
    weekStreakMet: 'Ugestime opfyldt',
    weekStreakMissed: 'Ugestime misset',
    periodStreakMet: 'Periode stime opfyldt',
    periodStreakMissed: 'Periode stime misset',
    totalStreakWeeks: 'Samlet stime: {count} uger',
    totalStreakPeriods: 'Samlet stime: {count} perioder',
    daysUntilStreakBreaks: 'Dage til stime bryder',
    lastDayToMaintainStreak: 'Sidste dag for at vedligeholde din stime!',
    // Milestone Tracker (shown on interaction history page)
    milestoneAchieved: 'Milepæl opnået!',
    achievedMilestones: 'Opnåede milepæle',
    noMilestonesYet: 'Ingen milepæle opnået endnu. Begynd at oprette forbindelse for at låse din første milepæl op! 🌱',
    achieved: 'Opnået',
    nextMilestones: 'Næste milepæle',
    milestoneFirstContact: 'Første kontakt',
    milestoneFirstContactDesc: 'Foretaget din første kontakt med denne ven',
    milestoneWeekStrong: 'En uge stærk',
    milestoneWeekStrongDesc: 'Vedligeholdt kontakt i en uge',
    milestoneMonthlyChampion: 'Månedlig mester',
    milestoneMonthlyChampionDesc: 'Konsistent kontakt i en måned',
    milestoneDeepConnection: 'Dyb forbindelse',
    milestoneDeepConnectionDesc: 'Havde en meningsfuld samtale',
    milestoneRitualMaster: 'Ritualmester',
    milestoneRitualMasterDesc: 'Etableret et venskabsritual',
    milestoneJourneyComplete: 'Rejse fuldført',
    milestoneJourneyCompleteDesc: 'Fuldført en venskabsrejse',
    // Contact Type Values
    contactTypeCall: 'Opkald',
    contactTypeEmail: 'E-mail',
    contactTypeText: 'Besked',
    contactTypeVideo: 'Videoopkald',
    contactTypeMeeting: 'Møde',
    contactTypeOther: 'Andet',
    
    // Friendship Needs Assessment
    discoverYourFriendshipNeeds: 'Opdag dine venskabsbehov',
    assessmentIntro: 'Denne vurdering hjælper dig med at forstå, hvad du virkelig har brug for fra dine venskaber. Ved at besvare et par spørgsmål får du indsigt i:',
    idealFriendshipStyle: 'Din ideelle venskabsstil og dybde',
    socialInteractionEnergy: 'Hvor meget social interaktion giver dig energi',
    supportValue: 'Hvilken slags støtte du værdsætter mest',
    communicationPreferences: 'Dine kommunikationspræferencer',
    realisticGoals: 'Realistiske mål for dine venskaber',
    answersHelpSetGoals: 'Dine svar hjælper dig med at sætte meningsfulde mål og spore din fremgang mod "venskabssucces" - uanset hvad det betyder for dig.',
    startAssessment: 'Start vurdering',
    retakeAssessment: 'Tag vurderingen igen',
    question: 'Spørgsmål',
    of: 'af',
    next: 'Næste',
    previous: 'Forrige',
    finish: 'Afslut',
    yourFriendshipProfile: 'Din venskabsbehov og stilprofil',
    basedOnYourAnswers: 'Baseret på dine svar, her er din venskabsbehovsprofil:',
    recommendations: 'Designprincipper',
    setYourGoals: 'Sæt dine mål',
    viewGoals: 'Se mål',
    yourTopPriorities: 'Dine top prioriteter',
    // Need names
    needEmotional: 'Følelsesmæssig',
    needSocial: 'Social',
    needFrequency: 'Frekvens',
    needSupport: 'Støtte',
    needPractical: 'Praktisk',
    needCommunication: 'Kommunikation',
    needGrowth: 'Vækst',
    needFun: 'Sjov',
    needDepth: 'Dybde',
    needTime: 'Tid',
    needRepair: 'Reparation',
    // Need descriptions
    needDescriptionEmotional: 'Du værdsætter følelsesmæssig nærhed og sårbarhed i venskaber. Mennesker med denne profil føler sig mest opfyldt, når venskaber inkluderer ærlighed, følelsesmæssig tryghed og gensidig støtte.',
    needDescriptionSocial: 'Du værdsætter social forbindelse og delte oplevelser i venskaber. Mennesker med denne profil føler sig mest opfyldt, når venskaber inkluderer regelmæssige sociale aktiviteter, gruppeinteraktioner og en følelse af tilhør.',
    needDescriptionFrequency: 'Du værdsætter konsistent kontakt og regelmæssig forbindelse i venskaber. Mennesker med denne profil føler sig mest opfyldt, når venskaber inkluderer hyppige tjek-ins, pålidelig kommunikation og løbende tilstedeværelse i hinandens liv.',
    needDescriptionSupport: 'Du værdsætter gensidig støtte og at være der for hinanden i venskaber. Mennesker med denne profil føler sig mest opfyldt, når venskaber inkluderer pålidelig hjælp under udfordringer, følelsesmæssig tilgængelighed og gensidig omsorg.',
    needDescriptionPractical: 'Du værdsætter praktisk hjælp og delte aktiviteter i venskaber. Mennesker med denne profil føler sig mest opfyldt, når venskaber inkluderer at gøre ting sammen, håndgribelig assistance og kollaborative oplevelser.',
    needDescriptionCommunication: 'Du værdsætter åben og ærlig kommunikation i venskaber. Mennesker med denne profil føler sig mest opfyldt, når venskaber inkluderer klar dialog, gennemsigtighed og direkte udtryk for tanker og følelser.',
    needDescriptionGrowth: 'Du værdsætter personlig vækst og læring i venskaber. Mennesker med denne profil føler sig mest opfyldt, når venskaber inkluderer delte læringsoplevelser, gensidig inspiration og muligheder for udvikling.',
    needDescriptionFun: 'Du værdsætter sjov og lette øjeblikke i venskaber. Mennesker med denne profil føler sig mest opfyldt, når venskaber inkluderer delt latter, sjove aktiviteter og positiv energi.',
    needDescriptionDepth: 'Du værdsætter dybde og meningsfuld forbindelse i venskaber. Mennesker med denne profil føler sig mest opfyldt, når venskaber inkluderer dybe samtaler, ægte forståelse og kvalitet over kvantitet.',
    needDescriptionTime: 'Du værdsætter at investere tid og energi i venskaber. Mennesker med denne profil føler sig mest opfyldt, når venskaber inkluderer regelmæssig tid sammen, konsistent tilstedeværelse og meningsfuld tidsinvestering.',
    needDescriptionRepair: 'Du værdsætter at adressere konflikter og reparere relationer, når ting går galt. Mennesker med denne profil føler sig mest opfyldt, når venskaber inkluderer åben kommunikation om problemer, vilje til at arbejde gennem udfordringer og etablerede reparationsritualer.',
    needDescriptionDefault: 'Et vigtigt aspekt af dine venskabsbehov',
    // Design Principles
    recommendationEmotional: 'Design venskaber omkring dybere forbindelser',
    recommendationFrequency: 'Vælg konsistens over intensitet',
    recommendationSocial: 'Prioriter delte oplevelser og regelmæssig forbindelse',
    recommendationSupport: 'Vær eksplicit om behov for støtte tidligt',
    recommendationDepth: 'Design venskaber omkring dybere forbindelser',
    recommendationRepair: 'Byg reparationsritualer, ikke perfekt harmoni',
    recommendationQuantityFew: 'Sigte efter 2-4 nære venskaber, hvor du kan investere dybt',
    recommendationQuantityModerate: 'Sigte efter 5-8 nære venskaber for en balanceret social kreds',
    recommendationQuantityMany: 'Sigte efter 9+ venskaber for at bygge et mangfoldigt socialt netværk',
    recommendationDefault1: 'Byg balancerede venskaber, der tilpasser sig forskellige behov',
    recommendationDefault2: 'Vælg konsistens over intensitet',
    suggestedGoalsBasedOnAssessment: '💡 Foreslåede mål baseret på din vurdering',
    clickRecommendationToAddGoal: 'Klik på ethvert princip for at tilføje det som et mål',
    progressOverview: 'Fremskridtsoversigt',
    completed: 'Fuldført',
    totalGoals: 'Samlede mål',
    progress: 'Fremskridt',
    noGoalsYet: 'Ingen mål endnu. Tilføj dit første mål ovenfor!',
    goalInputPlaceholder: 'F.eks. Have ugentlige tjek-ins med 3 nære venner',
    addGoal: 'Tilføj mål',
    confirmDeleteGoal: 'Er du sikker på, at du vil slette dette mål?',
    yourKeyTargets: 'Dine vigtigste venskabsmål',
    summaryEmotionalDepth: 'Du foretrækker, at dine nære venskaber føles: {depth}',
    summaryCloseFriendsQuantity: 'Du vil gerne vedligeholde omkring {target} nære venner.',
    summaryQuantityRealismNote: 'Med din nuværende tid og energi kan dette være ambitiøst — vi kan altid justere senere.',
    goalsAnchoredInTargets: 'Mål forankret i det, du sagde, du ønsker',
    goalsAnchoredInTargetsHelp: 'Disse mål er baseret på den følelsesmæssige dybde og det antal nære venner, du valgte i vurderingen.',
    autoGoalCloseFriendsCount: 'Opbyg og vedligehold omkring {target} nære venskaber.',
    progressTowardGoals: 'Din fremgang mod målene',
    closeFriendsProgress: 'Nære venner mål',
    closeFriendsRemaining: 'Du mangler {count} nære ven(ner) for at nå dit mål.',
    closeFriendsGoalReached: '🎉 Du har nået dit mål for nære venner!',
    emotionalDepthProgress: 'Følelsesmæssig dybde mål',
    emotionalDepthHasFriends: 'Du har {count} nære ven(ner) at udvikle {level} forbindelser med.',
    emotionalDepthNoFriends: 'Start med at tilføje nære venner for at arbejde mod dit følelsesmæssige dybde mål.',
    autoGoalEmotionalDepth: 'Prioritér venskaber, der føles {depth} for dig.',
    addCloseFriends: 'Tilføj nære venner',
    nurtureFriendships: 'Plej venskaber',
    todaysFriendshipAction: 'Dagens venskabsaktion',
    whyThisMatters: 'Hvorfor det betyder noget',
    howToDoIt: 'Sådan gør du det',
    effortLevel: 'Anstrengelsesniveau:',
    
    // Edit Notes
    notesPlaceholderFriend: 'Skriv nogle personlige noter (interesser, kontekst osv.)',
    
    // Friend Profile - Date/Time Formatting
    never: 'Aldrig',
    oneDayAgo: '1 dag siden',
    profileDaysAgo: '{count} dage siden',
    oneWeekAgo: '1 uge siden',
    profileWeeksAgo: '{count} uger siden',
    oneWeek: '1 uge',
    weeks: '{weeks} uger',
    oneDay: '1 dag',
    days: 'dage',
    and: 'og',
    ago: 'siden',
    oneMonthAgo: '1 måned siden',
    profileMonthsAgo: '{count} måneder siden',
    oneYearAgo: '1 år siden',
    profileYearsAgo: '{count} år siden',
    
    // Friend Profile - Interaction Alerts
    noRecentInteraction: 'Ingen nylig interaktion',
    recentlyConnected: 'For nylig forbundet',
    overdueForContact: 'Forfalden til kontakt',
    longTimeSinceLastContact: 'Lang tid siden sidste kontakt',
    
    // Friend Profile - Overview Cards
    notSetYet: 'Ikke sat endnu',
    nothingPlannedYet: 'Intet planlagt endnu',
    data: 'Data',
    comingSoon: 'Kommer snart',
    contactFrequency: 'Kontaktfrekvens',
    birthday: 'Fødselsdag',
    tapToEdit: 'Tryk for at redigere',
    
    // Friend Profile - Contact Frequency Options
    daily: 'Dagligt',
    weekly: 'Ugentligt',
    biweekly: 'Hver anden uge',
    monthly: 'Månedligt',
    quarterly: 'Kvartalsvis',
    
    // Friend Profile - Journeys
    friendshipJourneys: 'Venskabsrejser',
    ofActivities: 'af {total} aktiviteter',
    progress: 'Fremskridt',
    friendshipJourney: 'Venskabsrejse',
    unknownFriend: 'Ukendt ven',
    
    // Friend Profile - Premium Lock
    premiumFeature: 'Premium-funktion',
    upgradeToAccessProfiles: 'Opgrader for at få adgang til detaljerede venprofiler og avancerede sporingfunktioner.',
    
    // Friend Profile - Error State
    debugInfo: 'Fejlfinding:',
    friendIdLabel: 'Ven-ID:',
    currentUserLabel: 'Nuværende bruger:',
    authenticated: 'Autentificeret',
    notAuthenticated: 'Ikke autentificeret',
    userIdLabel: 'Bruger-ID:',
    notAvailable: 'Ikke tilgængelig',
    
    // Friendship Types (for modal)
    friendshipTypeAcquaintance: 'Bekendt eller uformel',
    friendshipTypeAcquaintanceDesc: 'Folk du kender ved navn og interagerer med lejlighedsvis (kolleger, naboer, klassekammerater).',
    friendshipTypeActivityBased: 'Aktivitetsbaseret',
    friendshipTypeActivityBasedDesc: 'Centreret omkring en delt hobby eller kontekst—som en træningspartner eller gamingpartner.',
    friendshipTypeSituational: 'Situationel eller omstændighedsmæssig',
    friendshipTypeSituationalDesc: 'Dannet fordi I er i samme livsfase eller miljø (kollegieværelseskammerat, nyforældregruppe).',
    friendshipTypeClose: 'Nær eller bedste ven',
    friendshipTypeCloseDesc: 'Dybt gensidig kærlighed, tillid og konsistent følelsesmæssig støtte.',
    friendshipTypeLifelong: 'Livslangt eller beslægtet ånd',
    friendshipTypeLifelongDesc: 'Relationer der varer gennem årtier og livsændringer.',
    friendshipTypeMentorMentee: 'Mentor–Mentee',
    friendshipTypeMentorMenteeDesc: 'Et venskab hvor én person er betydeligt mere erfaren eller ældre.',
    friendshipTypeWorkplace: 'Arbejdsplads eller professionelt',
    friendshipTypeWorkplaceDesc: 'Kolleger som du deler kammeratskab med ud over formelle pligter.',
    friendshipTypeChosenFamily: 'Valgt familie',
    friendshipTypeChosenFamilyDesc: 'Venner der fylder roller lignende familie—især når biologisk familie er fraværende eller fjern.',
    friendshipTypeDigitalFirst: 'Digital-først eller online',
    friendshipTypeDigitalFirstDesc: 'Bånd dannet primært gennem digitale rum (gamingfællesskaber, sociale medier, fora).',
    
    goalText: 'Måltekst',
    saveGoals: 'Gem mål',
    skipForNow: 'Spring over for nu',
    
    // Additional keys
    notStarted: 'Ikke startet',
    totalJourneys: 'Samlede rejser',
    noJourneysFound: 'Ingen rejser fundet',
    noJourneysYet: 'Du har ikke startet nogen venskabsrejser endnu. Besøg Venskabssporing for at starte din første rejse!',
    noActiveJourneys: 'Du har ingen aktive rejser lige nu.',
    noCompletedJourneys: 'Du har ikke fuldført nogen rejser endnu.',
    goToFriendshipTracker: 'Gå til Venskabssporing',
    inProgress: 'I gang',
    allJourneys: 'Alle rejser',
    
    // Footer
    privacyPolicy: 'Fortrolighedspolitik',
    termsAndConditions: 'Vilkår og betingelser',
  }
};

// Helper function to get translation with support for placeholders
export const getTranslation = (key, language = 'en', params = {}) => {
  const translation = translations[language]?.[key] || translations.en[key] || key;
  
  // Replace placeholders like {count}
  return translation.replace(/\{(\w+)\}/g, (match, paramKey) => {
    return params[paramKey] !== undefined ? params[paramKey] : match;
  });
};

